export default __webpack_public_path__ + "static/media/icon_mobile_menu_intro.ed8021a0.svg";